import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F3F3F3" />
      <Path
        d="M9.93 15.797l-2.812 4.22a.703.703 0 00.364 1.057l2.33.772v5.638c0 .303.195.572.482.668l8.485 2.812c.059.02.145.036.221.036a.754.754 0 00.221-.036l8.485-2.812a.703.703 0 00.482-.668v-5.638l2.33-.772a.703.703 0 00.364-1.058l-2.813-4.218a.706.706 0 00-.364-.278l-5.292-1.751 1.303-1.303a.703.703 0 00-.497-1.2h-2.11V7.703A.703.703 0 0020.406 7h-2.812a.703.703 0 00-.703.703v3.563h-2.11a.703.703 0 00-.497 1.2l1.303 1.303-5.292 1.751a.714.714 0 00-.364.277zm.873 1.227l7.1 2.353-2.003 3.006-7.1-2.354 2.003-3.005zm.416 5.288l4.747 1.574c.3.1.63-.014.807-.277l1.524-2.287v8.001l-7.078-2.346v-4.665zm15.562 4.665l-7.078 2.346v-8l1.524 2.286a.703.703 0 00.807.277l4.747-1.574v4.665zm-4.68-4.594l-2.004-3.006 7.1-2.353 2.003 3.005-7.1 2.354zm-4.507-9.711a.703.703 0 00.703-.703V8.406h1.406v3.563c0 .388.315.703.703.703h1.115L19 15.193l-2.521-2.521h1.115zm.909 4.013a.7.7 0 00.994 0l1.803-1.803 3.948 1.306L19 18.26l-6.248-2.07 3.948-1.307 1.803 1.803z"
        fill="#000"
        fillOpacity={0.6}
      />
    </Svg>
  );
}

export default SvgComponent;
